const plaid = {
  // @ts-ignore
  PLAID_PK: window._env_.REACT_APP_PLAID_PK,
  // @ts-ignore
  PLAID_ENV: window._env_.REACT_APP_PLAID_ENV,
};

export default plaid;
